/** @jsx jsx */
import { jsx } from "theme-ui"
import { MenuList } from "@reach/menu-button"

export default function Dropdown(props) {
  return (
    <MenuList
      sx={{
        position: "relative",
        bottom: "-3.2em",
        backgroundColor: "white",
        border: "none",
        boxShadow: "card",
        borderRadius: "19px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        minWidth: "95px",
        color: "heading",

        "&::before, &::after": {
          top: "100%",
          left: "21px",
          border: "solid transparent",
          content: '" "',
          height: 0,
          width: 0,
          position: "absolute",
          pointerEvents: "none",
        },

        "&::after": {
          borderColor: "transparent",
          borderTopColor: "white",
          borderWidth: "7px",
          marginLeft: "-7px",
        },

        "&::before": {
          borderColor: "rgba(112, 112, 112, 0)",
          borderTopColor: "#707070",
          borderWidth: "8px",
          marginLeft: "-8px",
        },
      }}
      {...props}
    />
  )
}
